import React from 'react';

const Spinner = ({ addCssStyle }) => {
  return (
    <div className='loadingio-spinner-eclipse-ebyrvwal62m' style={addCssStyle}>
      <div className='ldio-yuuyfzy0ot'>
        <div></div>
      </div>
    </div>
  );
};

export default Spinner;
